import { getDate } from '@/service/v3/endpoints/events'
import { useSWR } from '@attensi/swr'
import { computed, unref } from 'vue'
import type { MaybeRef } from '../usePolicyTypeSelection'
import { useOnError } from './helpers/useOnError'

const getDateOrUndefined = (dateId: number | undefined) => {
  if (!dateId) return undefined
  return getDate(dateId)
}

export const useDate = (dateId?: MaybeRef<number | undefined>) => {
  const dateParams = [dateId, 'get-date']
  const { data: date, error, mutate } = useSWR(dateParams, getDateOrUndefined)
  useOnError(error)

  const isLoadingDate = computed(() => {
    return (
      !date.value &&
      (unref(dateId) !== undefined || unref(dateId) !== null) &&
      unref(dateId)?.toString().endsWith('0000000')
    )
  })

  const unwrappedDate = computed(() => {
    return {
      id: date.value?.data?.id ?? null,
      ...(date.value?.data?.attributes ?? null),
    }
  })

  return { date, isLoadingDate, unwrappedDate, mutate }
}
